import React, {useContext, useEffect, useState} from 'react';
import styles from './layout.module.css';
import NavbarTest from "../../common/navigation/navbar-test";
import {Outlet, useLocation, useParams} from "react-router-dom";
import {MobileMenuContext} from "../../common/context/mobile-menu-context";
import FooterXsci from "../../common/footer/footer-xsci";
import HeroBanner from "../banner/HeroBanner";
import NavBar from "../../v2/layout/navigation/navBar";

const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return width;
};

const Layout: React.FC = () => {
    const width = useWindowWidth();
    const {isMobileMenuOpen, setIsMobileMenuOpen} = useContext(MobileMenuContext);

    const { categoryName } = useParams();


    useEffect(() => {
        console.log("isMobileMenuOpen <<LAYOUT>>", isMobileMenuOpen);
    }, [isMobileMenuOpen]);
    // Show SearchBar only for widths less than 1024px (mobile + regular iPad)
    const isMobileOrRegularIpad = width < 1024;

    useEffect(() => {
        console.log(">>lll, ",categoryName)
    }, []);


    const location = useLocation();

    return (
        <>
            <NavBar/>

            <HeroBanner
                backgroundImageUrl={"/images/banner/bannertest.jpg"}
                title={""}
            />

            <div className={styles.page_rapper}>
                <main className={styles.page_container}>
                    <section className={styles.products_content}>
                        <Outlet/>
                    </section>
                </main>
            </div>
            <FooterXsci/>
        </>
    );
};

export default Layout;
